const TitleComponent = () => {
    return ( <>HydroMetLab</> );
}
 
export default TitleComponent;